module.exports = __webpack_public_path__ + "img/giftpackage_level2.d6b7cfd9.png";